import { MessageType } from 'models/twilio';

const getSentItemNature = (msgType) => {
  switch (msgType) {
    case MessageType.File:
      return 'FileUpload_Send';
    case MessageType.ContactCard:
      return 'NameCard_Send';
    default:
      return 'TextMessage_Send';
  }
};

export default getSentItemNature;
